// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"38d8411a","188":"bc4361bb","528":"10bab096"}[chunkId] + ".chunk.css";
};